import { render, staticRenderFns } from "./selectPage.vue?vue&type=template&id=15c54f32&scoped=true"
import script from "./selectPage.vue?vue&type=script&lang=js"
export * from "./selectPage.vue?vue&type=script&lang=js"
import style0 from "./selectPage.vue?vue&type=style&index=0&id=15c54f32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c54f32",
  null
  
)

export default component.exports